import { MAZE } from '../constants/measure';
import INSTRUCTIONS from './mazeConstants';
import { fetchMazeContent, saveMazeResponse } from './mazeActions';

const MazeFlowStrategy = {
    measure: MAZE.MEASURE,
    assessment: MAZE.ASSESSMENT,
    instructions: INSTRUCTIONS,
    fetchContent: fetchMazeContent,
    saveResponse: saveMazeResponse,
    supportsUntimedAssessment: true,
};

export default MazeFlowStrategy;
